export function getMonthName(month: number, short?: boolean) {
  switch (month) {
    case 1:
      return short ? 'MONTH.JAN' : 'MONTH.JANUARY';
    case 2:
      return short ? 'MONTH.FEB' : 'MONTH.FEBRUARY';
    case 3:
      return short ? 'MONTH.MAR' : 'MONTH.MARCH';
    case 4:
      return short ? 'MONTH.APR' : 'MONTH.APRIL';
    case 5:
      return short ? 'MONTH.MAY_SHORT' : 'MONTH.MAY';
    case 6:
      return short ? 'MONTH.JUN' : 'MONTH.JUNE';
    case 7:
      return short ? 'MONTH.JUL' : 'MONTH.JULY';
    case 8:
      return short ? 'MONTH.AUG' : 'MONTH.AUGUST';
    case 9:
      return short ? 'MONTH.SEP' : 'MONTH.SEPTEMBER';
    case 10:
      return short ? 'MONTH.OCT' : 'MONTH.OCTOBER';
    case 11:
      return short ? 'MONTH.NOV' : 'MONTH.NOVEMBER';
    case 12:
      return short ? 'MONTH.DEC' : 'MONTH.DECEMBER';

    default:
      return '';
  }
}
